import { useEffect, useState } from 'react';
import { useAuth } from '@frontegg/react';
import { Loader2 } from 'lucide-react';
import { TechOnboarder } from '../components/TechOnboarder';
import { listChatThreads } from '../services/data.store';

export default function OnboardingPage() {
  const { user } = useAuth();
  const [latestThreadId, setLatestThreadId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLatest = async () => {
      try {
        const threads = await listChatThreads('tech_onboarder', 1, user?.id);
        if (threads.length > 0) {
          setLatestThreadId(threads[0].thread_id);
        }
      } catch (err) {
        console.error('Failed to load onboarding threads:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchLatest();
  }, [user?.id]);

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border">
        <h1 className="text-2xl font-bold text-foreground">Onboarding</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Get your data connected and organized with guided assistance.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <TechOnboarder
            showHistory={true}
            conversationId={latestThreadId || undefined}
          />
        )}
      </div>
    </div>
  );
}
